export default [
  {
    answer: `Yes, you can buy weed products online in states where marijuana has been legalized for medical or recreational use. In most cases, when you buy weed online, you do not pay for your product until you receive it—either when you pick up your order at a local dispensary or get it delivered to your house through a <a href="/delivery">weed delivery service</a>.`,
    question: "Can I buy weed products online?",
  },
  {
    answer: `Yes, online weed stores are legal because there is no exchange of money or payment until you physically visit the <a href="/dispensaries">dispensary</a> you ordered from to pick up your online weed order.`,
    question: "Are online weed stores legal?",
  },
  {
    answer:
      "You can buy cannabis online by placing an order on Leafly.com for pick up at a cannabis dispensary near you. You can also use Leafly.com to find the closest dispensary near you and all the types of cannabis products they carry.",
    question: "Where can I buy cannabis online near me?",
  },
];
